import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Head from 'next/head';

import { embeddedAssetOptions } from 'hub/helpers/contentful';
import { parseContentfulCateringCategories } from 'lib/contentful/cateringCategoryMapping';
import { QualificationProvider } from 'qualification/context';
import useCity from 'qualification/hooks/usePreselectedCity';
import MainLayout from 'shared/layouts/MainLayout';
import PageSections from 'static_pages/marketing_pages/dynamic_landing_page/components/PageSections';
import { buildFaqMarkup } from 'static_pages/marketing_pages/helpers';

export default function DynamicLandingPage({ page, ratings }) {
  const parsedCateringCategories = parseContentfulCateringCategories(
    page.keywords
  );

  const city = useCity({ cityFromPath: page.city });

  const body = documentToReactComponents(
    page.body,
    embeddedAssetOptions({
      ratings: ratings,
    })
  );

  return (
    <MainLayout ratings={ratings} renderNavbarCta={() => null}>
      <QualificationProvider
        storage={null}
        initialized={{
          nonSkippableQuestions: ['catering_categories'],
          answers: {
            city,
            catering_categories: parsedCateringCategories,
          },
        }}
      >
        <Head>
          <title>{page.metaTitle}</title>
          <meta name="description" content={page.metaDescription} />
          <meta property="og:title" content={page.metaTitle} />
          <meta property="og:description" content={page.metaDescription} />

          {page.faQsEnabled && page?.faQs?.length && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(buildFaqMarkup(page.faQs)),
              }}
            />
          )}
        </Head>
        <PageSections.Provider>{body}</PageSections.Provider>
      </QualificationProvider>
    </MainLayout>
  );
}
